// extracted by mini-css-extract-plugin
export var menu = "home-menu-module--menu--5ee84";
export var menu__cards = "home-menu-module--menu__cards--483b0";
export var menu__cardsButton = "home-menu-module--menu__cardsButton--f53ca";
export var menu__cardsButtonPhone = "home-menu-module--menu__cardsButtonPhone--1482d";
export var menu__cardsButtonText = "home-menu-module--menu__cardsButtonText--2033c";
export var menu__cardsButtonsContainerDesktop = "home-menu-module--menu__cardsButtonsContainerDesktop--e0ddb";
export var menu__cardsButtonsContainerMobile = "home-menu-module--menu__cardsButtonsContainerMobile--44876";
export var menu__cardsContent = "home-menu-module--menu__cardsContent--8bc8e";
export var menu__cardsContentHeader = "home-menu-module--menu__cardsContentHeader--463a3";
export var menu__cardsImg = "home-menu-module--menu__cards-img--91307";
export var menu__cardsItem = "home-menu-module--menu__cards-item--ab433";
export var menu__cardsLink = "home-menu-module--menu__cards-link--14395";
export var menu__cardsName = "home-menu-module--menu__cardsName--96ae1";
export var menu__cardsSubtitle = "home-menu-module--menu__cardsSubtitle--649c2";
export var menu__cardsSubtitle2 = "home-menu-module--menu__cardsSubtitle2--309a5";
export var menu__cardsSubtitleContainer = "home-menu-module--menu__cardsSubtitleContainer--85b87";
export var menu__wrapp = "home-menu-module--menu__wrapp--cf44d";
export var minOrderInfo = "home-menu-module--minOrderInfo--ee94f";
export var minOrderInfo__text = "home-menu-module--minOrderInfo__text--03ab6";
export var subtitle = "home-menu-module--subtitle--4f864";
export var title = "home-menu-module--title--df822";